module.exports = "<div class=\"weui_cells_title\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cells-title.vue
 ** module id = 56
 ** module chunks = 0
 **/